
import React, { useState, useEffect, useRef } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Slider from "react-slick";
import styles from '../../../utilities/Sections/Img&Text/about.module.css';
// import Modal from '@/utilities/SciencePage/ModalSciencePage/Modal';
const ImgText = () => {

    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const slidesData = [
        {
            title: "About Us",
            text: "We’re Italian and family-owned, with a deep passion for connecting people to the best, purest ingredients. Inspired by the Mediterranean Lifestyle, we believe in its power to nourish both mind and body. Home to two of the world’s renowned Blue Zones, the Mediterranean is a region where vibrant living and longevity—often beyond 100 years—are celebrated daily. Our mission is to bring this philosophy to your table, blending tradition, health, and exceptional taste.",
            image1: "images/BMD-GG-i1-Donna-Fugata-P1106965+_v2.webp",
            image2: "images/BMD-01-Sicily-Donna-Fugata-P1107190+_v2.webp",
            quote: "To live in harmony with nature, to share a table with friends, and to nourish both the body and soul—this is the essence of the good life.",
            quoteAuthor: "Socrates"
        },
        {
            title: "Our Mission",
            text: "Our mission at Bruno MD is to empower people to live their healthiest and most vibrant lives. We achieve this by combining uncompromising natural ingredients with the power of scientific imagination. Guided by a commitment to excellence, we innovate products that prioritize purity, effectiveness, and sustainability. Our approach bridges the best of nature and science to support holistic well-being. At Bruno MD, we believe that health is the foundation of a fulfilled life, and we are dedicated to helping you thrive every step of the way.",
            image1: "images/BMD_i1-GG-CDG-69-v2.webp",
            image2: "images/BMD_i1-GG-CDG-73-v2.webp",
            quote: "Let food be thy medicine and medicine be thy food.",
            quoteAuthor: "Hippocrates"
        },
        {
            title: "Our Vital Nature",
            text: "Our vital nature lies in embracing the essence of what our land offers. At Bruno MD, we prioritize ingredients that thrive in Italy’s rich soil and unique climate, ensuring every product is rooted in authenticity. These conditions nurture crops renowned for their extraordinary healing properties, cherished by locals for generations. By harnessing this natural bounty, we create wellness solutions that honor tradition while supporting modern health. It’s a commitment to quality, sustainability, and the timeless wisdom of the land we call home.",
            image1: "images/Bruno-MD-Hands-V3.webp",
            image2: "images/Bruno-MD-Hands-V3(02).webp",
            quote: "Italy’s unique combination of soil and climate produces crops that are not only rich in flavor but also potent in healing properties. Locals have known for centuries that their produce—from the olive oil to the tomatoes—contains compounds that can improve heart health, reduce inflammation, and support overall well-being.",
            quoteAuthor: "Ethnobotanist Dr. James A. Duke, author of The Green Pharmacy"
        },
        {
            title: "Our Philosophy",
            text: "Our philosophy is rooted in the simplicity of gathering around a shared family table, where fresh ingredients nourish both body and spirit. Dr. Bruno believes that science holds the power to unlock nature’s potential, delivering natural ingredients in innovative ways to enhance your well-being. This commitment to blending tradition with modern science inspires everything we create, ensuring our products help you look and feel your best. At the core of our work lies a dedication to authenticity, quality, and the transformative power of nature.",
            image1: "images/BMD-GG_BMDROM4-54+_v2.webp",
            image2: "images/Our Philosophy1.png",

            quote: "Good food should be a right, not a privilege. It brings people together and nourishes the soul. Fresh ingredients and the act of sharing a meal around the family table is the simplest form of nourishment for both body and spirit.",
            quoteAuthor: "Alice Waters, pioneer of the farm-to-table movement.",
           
        },
        {
            title: " Why Choosing Bruno MD",
            text: "Choose Bruno MD health products and embrace the Mediterranean Lifestyle. Live the Italian way—the healthiest in the world! Nourish your body and soul with every bite. Join us at our table and savor life. Rediscover health, vitality, and joy.",
            image1: "images/BMD-i3-FilippoFior-FIO_0165+_v3.webp",
            image2: "images/BMD-i3-FilippoFior-FIO_0165+_v3(02).webp",
            quote: "In the sun-kissed fields of Italy, where olive trees sway, we find the true essence of wellness—nourishing our bodies with the bounty of the earth, embracing the joy of simple pleasures, and weaving health into every meal, every moment. For in the Mediterranean, life flows like fine wine, vibrant and full, reminding us that true health is found not just in products, but in the love and laughter shared at the table.",
            quoteAuthor: "Frances Mayes, writer, well-known for her book Under the Tuscan Sun.",

        }
    ];




    const nextSlide = () => {
        sliderRef.current.slickNext();
    };

    const prevSlide = () => {
        sliderRef.current.slickPrev();
    };
    return (
        <section id='aboutPage' className={styles.sliderContainer}>
            <Slider {...settings} ref={sliderRef}>
                {slidesData.map((slide, index) => (
                    <div className={styles.aboutMain} key={index}>
                        <div className={styles.part1}>
                            <img src={slide.image1} alt={`Slide ${index + 1}`} />
                        </div>
                        <div className={styles.part2}>
                            <div className={styles.Part2_Scroll}>
                                <h2>{slide.title}</h2>
                                <p>{slide.text}</p>
                            </div>

                            <div className={styles.dottedDiv}>
                                <p>
                                    &#34;{slide.quote}&#34; <br />
                                    <b>{slide.quoteAuthor}</b>
                                    {/* Conditional rendering for quote2 and quoteAuthor2 */}
                                    {slide.quote2 && slide.quoteAuthor2 && (
                                        <>
                                            <br />
                                            &#34;{slide.quote2}&#34; <br />
                                            <b>{slide.quoteAuthor2}</b>
                                        </>
                                    )}
                                </p>
                            </div>
                        </div>
                        <div className={styles.part3}>
                            <img src={slide.image2} alt={`Slide ${index + 1}`} />
                        </div>
                    </div>
                ))}
            </Slider>
            <div className={styles.btnWrap}>
                <div className={styles.custom_btnDiv}>
                    <button
                        onClick={prevSlide}
                        className={`${styles.sliderButton} ${styles.prev_button}`}
                    >
                        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.1641 26L45.4974 26" stroke="#7F7F7F" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.68932 26.2144L13.9538 31.773C14.487 32.093 15.1654 31.7089 15.1654 31.087L15.1654 20.913C15.1654 20.2911 14.487 19.907 13.9538 20.227L4.68932 25.7856C4.52749 25.8827 4.52749 26.1173 4.68932 26.2144Z" fill="#7F7F7F" />
                        </svg>
                    </button>
                    <button
                        onClick={nextSlide}
                        className={`${styles.sliderButton} ${styles.next_button}`}
                    >
                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M37.832 26.832L7.50234 27.3025" stroke="#7F7F7F" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M48.3027 26.4545L38.9532 21.0402C38.4151 20.7285 37.7427 21.1231 37.7524 21.7449L37.9102 31.9177C37.9198 32.5395 38.6041 32.913 39.1323 32.5849L48.3094 26.8832C48.4697 26.7836 48.4661 26.5491 48.3027 26.4545Z" fill="#7F7F7F" />
                        </svg>
                    </button>
                </div>
            </div>
    </section>
  );
};

export default ImgText;
